import { MovieDetails } from '@intigral/shared';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ButtonTypes, CACHE_CONFIG_TYPES } from '../../config/constants';
import h from '../../helpers/common';
import url from '../../helpers/url';
import DetailsButton from './DetailsButton';
import LockIcon from './LockIcon';
import PlayVideoButton from './PlayVideoButton';
import AddWatchlistButton from './AddWatchlistButton';
import usePPVManagement from '../../hooks/usePPVManagement';
import { useConfiguration } from '../../hooks/useConfiguration';

interface WatchListEpisodeItemProps {
    item: any;
    onRemove: () => void;
    componentType: string;
    componentName: string;
    id: string;
}

const WatchListEpisodeItem: React.FC<WatchListEpisodeItemProps> = ({
    item,
    onRemove,
    componentType,
    componentName,
    id,
}) => {
    // Use PPV management hook for all PPV-related functionality
    const { shouldShowLock } = usePPVManagement();

    const channelId = item?.channelId || item?.channelID || item?.id;
    const { isLocked, enhancedChannel } = shouldShowLock(item, channelId);

    const navigate = useNavigate();
    const link = url.route(url.getDetailsPage(item.programType), { id: btoa(item.Id), guid: btoa(item.guid) });
    const { data: newConfig } = useConfiguration();
    return (
        <div className="eps-card masonry-item" id={id}>
            <div className="poster-container">
                <div className="img-link">
                    <img
                        src={h.getImagizerUrl(
                            item?.image_landscape
                                ? item?.image_landscape
                                : item?.images?.find((img) => img.type === 'cover')?.url,
                            newConfig?.imagizer?.components_images.WATCHLIST_SEASON_EPISODES_ITEM
                        )}
                    />
                </div>
                {!isLocked && (
                    <div className="over-poster">
                        <PlayVideoButton
                            buttonType={ButtonTypes.EpisodeItem}
                            item={item}
                            componentType={componentType}
                            componentName={componentName}
                        >
                            <span className="play-icon"> </span>
                        </PlayVideoButton>
                    </div>
                )}

                {isLocked && <LockIcon filled />}
                <AddWatchlistButton
                    item={item}
                    type={ButtonTypes.EpisodeItem}
                    onRemove={onRemove}
                    onClick={() => navigate(link)}
                    componentType={componentType}
                    componentName={componentName}
                />
            </div>
            <div className="eps-poster-detail">
                <DetailsButton
                    buttonType={ButtonTypes.EpisodeItem}
                    item={item}
                    componentType={componentType}
                    componentName={componentName}
                    meta={{}}
                >
                    <div className="eps-poster-detail-text">
                        <h6>{item.text}</h6>
                        <MovieDetails info={[...(item.genre && item.genre), item.year ? `${item.year}` : null]} />
                    </div>
                </DetailsButton>
            </div>
        </div>
    );
};
export default WatchListEpisodeItem;
